module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3-providers/~/websocket/lib/version.js
// module id = 2658
// module chunks = 0 1